import { StyleSheet } from 'react-native';

export const style = StyleSheet.create({
  centerVertical: {
    flexGrow: 0,
    marginVertical: 'auto'
  },
  centerHorizontal: {
    marginLeft: 'auto',
    marginRight: 'auto'
  }
});
